import { routesUrl } from 'app/fuse-configs/navigationConfig';
import React from 'react';

const ValidationPageConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: routesUrl.accountConfirmation,
      component: React.lazy(() => import('./ValidationPage')),
    },
  ],
};

export default ValidationPageConfig;
